import Shops from "../symbols/shops";
import { HttpRequestPost } from "../../service";
export interface IFilter {
  Region?: string[] | null;
  City?: string[] | null;
}
type GetShopsRequestModel = {
  Filter: IFilter;
  Order: string;
  Query: string;
  Page: number;
  Size: number;
};
const getShopsAction = () => ({
  type: Shops.GET_SHOPS,
});
const getShopsSuccessAction = (data: any) => ({
  type: Shops.GET_SHOPS_SUCCESS,
  payload: data,
});
const getShopsFailureAction = (data: any) => ({
  type: Shops.GET_SHOPS_FAILURE,
  payload: data,
});
const clearGetShopsAction = () => ({
  type: Shops.CLEAR_GET_SHOPS,
});

export function getShops(
  data?: GetShopsRequestModel,
  callback?: (resp?: any) => void
) {
  return (dispatch: any) => {
    const url = "/merchant/shop/list";
    dispatch(getShopsAction());
    HttpRequestPost(
      url,
      dispatch,
      getShopsSuccessAction,
      getShopsFailureAction,
      true,
      data || {
        Query: "",
        Filter: { Status: [] },
        OrderBy: "desc",
      },
      callback
    );
  };
}

export function clearGetShops() {
  return (dispatch: any) => {
    dispatch(clearGetShopsAction());
  };
}
